import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  notificationPaper: {
    top: "0px",
    width: "358px",
    height: "110px",
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: "5px",
    paddingLeft: "12px",
    paddingRight: "12px",
    paddingBottom: "5px",
    left: 0,
    right: 0,
  },

  titleInitial: {
    fontWeight: "bold",
    fontSize: "13px",
    textAlign: "left",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  bodyInitial: {
    fontSize: "13px",
    textAlign: "left",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  link: {
    color: "blue",
    fontSize: "10px",
    textAlign: "left",
    textDecoration: "underline blue",
    marginLeft: "5px",
  },
  rowLink: {
    display: "flex",
    fontSize: "10px",
    textAlign: "left",
  },
  firstColumn: {
    width: "80%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    overflow: "hidden",
  },

  secondColumn: {
    width: "20%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },

  image: {
    height: "40px",
    width: "40px",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
  },
  inputRow: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "flex-end",
    alignContent: "center",
  },
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  inputImage: {
    display: "none",
  },
  rowAlignEnd: {
    display: "flex",
    alignSelf: "flex-end",
    justifyContent: "flex-end",
    alignItems: "end",
  },
  alertImage: {
    padding: "2px",
    width: "25px",
  },
  textExpanded: {
    marginBottom: "10px",
    fontSize: "15px",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "90vh",
    alignItems: "center",
  },
}));

export default style;
